import { Injectable } from '@angular/core';

import { CamLazyTranslationService } from '@camelot/translation';

@Injectable({
  providedIn: 'root',
})
export class CamTranslationUser extends CamLazyTranslationService {
  constructor() {
    super('user');
  }
}
